export default () => ({
  isShowing: false,
  isMobiled: false,
  next: false,
  notFound: false,
  notCode: false,
  check: {
    tenant_id: ''
  },
  tanant: {
    name: null
  },
  optionsGenre: [
    {
      id: 'male',
      name: 'Masculino'
    },
    {
      id: 'female',
      name: 'Feminino'
    }
  ],
  register: {
    tenant_id: null,
    name: '',
    birthdate: '',
    genre: null,
    country_register: null,
    phone: null,
    email: '',
    password: '',
    password_confirmation: '',
    sms: true,
    terms: false,
    internal_regulation: false,
    type: 'dweller'
  },
  terms: null,
  errors: {
  },
  errorTrue: false
})



// WEBPACK FOOTER //
// ./src/app/auth/register/dweller/resources/data.js